import { withInstall } from '@jdesign-vue/utils'

import Image from './src/image.vue'

export const JdImage = withInstall(Image)
export default JdImage

export * from './src/image'
